var _style, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgQu(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 36,
    height: 24,
    viewBox: "0 0 238 158",
    style: {
      enableBackground: "new 0 0 238 158"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0D24;}\n\t.st1{fill:#76CEDB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.1,90.8L62.1,90.8c-6,0-11.5-2.3-15.7-6.5c-4.2-4.2-6.5-9.7-6.5-15.7c0-5.9,2.3-11.5,6.5-15.7 c4.2-4.2,9.8-6.5,15.7-6.5H62c5.9,0,11.5,2.3,15.6,6.5c4.2,4.2,6.5,9.8,6.5,15.7c0,5.9-2.3,11.5-6.5,15.7 C73.6,88.5,68,90.8,62.1,90.8 M120.2,68.5c0-15.5-6.1-30.1-17.1-41.1c-11-11-25.7-17-41.2-17c-15.5,0-30.1,6.1-41.1,17.1 c-11,11-17,25.6-17,41.2c0,15.5,6.1,30.1,17.1,41.1c11,10.9,25.6,16.9,41,16.9h0.1c4.1,0,8.2-0.5,12.1-1.3 c10.8,13.6,27.4,22.1,45.6,22.1v-36c-5.2,0-10-1.8-13.9-4.9C115.2,96.1,120.3,82.7,120.2,68.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182,126.5c-28.8,0-52.2-23.4-52.2-52.2V57.2h36v17.1c0,8.9,7.3,16.2,16.2,16.2h0c4.3,0,8.4-1.7,11.4-4.7 c3.1-3.1,4.7-7.1,4.7-11.4V57.2h36v17.1c0,13.9-5.4,27-15.3,36.9C209,121.1,195.9,126.5,182,126.5L182,126.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.8,
    y: 12.3,
    className: "st1",
    width: 104.3,
    height: 34.1
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgQu);
export default __webpack_public_path__ + "static/media/img_qu.f2fee8131c66370a9cabd082e8215501.svg";
export { ForwardRef as ReactComponent };